var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',{staticClass:"layout-container"},[_vm._t("default",function(){return [_c('layout-sidebar'),_c('layout-main',[_c('layout-header',[_vm._t("header")],2),_c('layout-view')],1)]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }